import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const BreadcrumbWrapper = styled.div`
  padding: 8px 24px;
  border-bottom: 1px solid #d2d6da;
  font-size: 11px;
  color: #697684;
  line-height: 13px;
  font-weight: 300;

  @media (${mediaQuery.mobile}) {
    display: none;
  }
`;

export const BreadcrumbItemWrapper = styled.span`
  a {
    color: rgba(0, 0, 0, 0.45);
    transition: color 0.3s;
  }
`;
